import { inject, Injectable } from '@angular/core';
import { ComponentType } from '@angular/cdk/overlay';
import {
  DEFAULT_DIALOG_WIDTH,
  IDialogData,
  IDialogResponse,
  ITemplateDialogData,
} from '../../../components/dialogs/dialog';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { DialogComponent } from '../../../components/dialogs/dialog/dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private readonly dialog: Dialog = inject(Dialog);

  openDialog<T>(
    dialog: ComponentType<unknown>,
    response: IDialogData & T,
    disableClose: boolean = false
  ): DialogRef<IDialogResponse<T>, unknown> {
    return this.dialog.open<IDialogResponse<T>>(dialog, {
      data: response,
      disableClose,
    });
  }

  openGenericDialog<T>(
    configuration: ITemplateDialogData & T,
    disableClose: boolean = false
  ): DialogRef<IDialogResponse<T>, DialogComponent<T>> {
    const dialogRef = this.dialog.open<
      IDialogResponse<T>,
      ITemplateDialogData & T,
      DialogComponent<T>
    >(DialogComponent, { data: configuration, disableClose });
    const componentRef = dialogRef.componentRef!;

    componentRef.setInput('title', configuration.headline);
    componentRef.setInput('width', configuration.width ?? DEFAULT_DIALOG_WIDTH);
    componentRef.setInput('data', configuration);
    componentRef.setInput('content', configuration.content);
    componentRef.setInput('footer', configuration.footer);
    componentRef.setInput('subtitle', configuration.subtitle);
    componentRef.setInput('icon', configuration.icon);
    componentRef.setInput(
      'iconBackgroundColor',
      configuration.iconBackgroundColor
    );
    componentRef.setInput(
      'fontSize',
      configuration.fontSize === undefined
        ? undefined
        : `${configuration.fontSize}px`
    );
    componentRef.setInput('closingColor', configuration.closingColor);
    componentRef.setInput('isValid', configuration.isValid ?? true);
    componentRef.setInput('isSaveDialog', configuration.isSaveDialog ?? false);

    const subscription = componentRef.instance.onClose.subscribe(result => {
      dialogRef.close(result);
    });
    componentRef.onDestroy(() => subscription.unsubscribe());

    return dialogRef;
  }
}
